import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { CreateAgentFirmUserProps } from './types';

type CreateAgentFirmUserParams = {
  agentFirmId: string;
  data: CreateAgentFirmUserProps;
};

export async function createAgentFirmUser({
  agentFirmId,
  data,
}: CreateAgentFirmUserParams) {
  const response = await fetcher(`${API_BASE_PATH}/${agentFirmId}/users`, {
    method: 'POST',
    body: data,
  });

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error: responseData?.message || 'Failed to create agent firm user',
      statusCode: response.status,
    };
  }

  const responseData = await response.json();
  return {
    success: true,
    data: responseData.user,
  };
}
